import ListContainer from '../Common/ListContainer';
import LoadingSpinner from '../Common/LoadingSpinner';
import { Stack } from '@mui/material';
import ErrorBoundary from '../../hooks/errorBoundary';
import { DataGridPro, getGridStringOperators, GridColDef, huHU } from '@mui/x-data-grid-pro';
import React from 'react';
import EmptyListMessage from '../Common/EmptyListMessage';
import { PartnerDataGridProps } from './WorkerTravelDetailsPage';


const columns: GridColDef[] = [
    {
        field: 'workplaceName',
        headerName: 'Munkahely',
        flex: 1,
        sortable: true,
        headerAlign: 'left',
        align: 'left',
        renderHeader: () => <strong>Munkahely</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
    {
        field: 'numberOfWorkers',
        headerName: 'Bejelentkezett dolgozók száma',
        width: 220,
        sortable: true,
        filterable: false,
        headerAlign: 'right',
        align: 'right',
        renderHeader: () => <strong>Bejelentkezett dolgozók száma</strong>,
        filterOperators: getGridStringOperators().filter(({ value }) => ['contains'].includes(value)),
    },
];

export default function WorkplaceDataGrid({
                                              loading,
                                              partnerDeviceDetails,
                                              rowSelectionModel,
                                              setRowSelectionModel
                                          }: PartnerDataGridProps) {
    return <>
        {loading ? (
            <ListContainer>
                <LoadingSpinner />
            </ListContainer>
        ) : (
            Object.keys(partnerDeviceDetails).length > 0 ? (
                <Stack sx={{ height: 'calc(100vh - 500px)', mt: 1 }}>
                    <ErrorBoundary>
                        <DataGridPro
                            density={'compact'}
                            columns={columns}
                            rows={Object.keys(partnerDeviceDetails).map((workplaceName) => {
                                const workplaceWorkerDevices = partnerDeviceDetails[workplaceName];

                                if (!workplaceWorkerDevices) {
                                    return;
                                }
                                return {
                                    id: `${workplaceName}_${workplaceWorkerDevices.length > 0 ? workplaceWorkerDevices[0].workplaceId : 0}`,
                                    workplaceName: workplaceName,
                                    numberOfWorkers: workplaceWorkerDevices.length,
                                }
                            })}
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        { field: 'workplaceName', sort: 'asc' },
                                    ],
                                },
                            }}
                            rowHeight={35}
                            checkboxSelection
                            hideFooter={true}
                            getRowId={(row) => row.id}
                            rowSelectionModel={rowSelectionModel}
                            onRowSelectionModelChange={(selectedRows) => {
                                setRowSelectionModel(selectedRows);
                            }}
                            localeText={huHU.components.MuiDataGrid.defaultProps.localeText}
                            unstable_headerFilters
                        />
                    </ErrorBoundary>
                </Stack>
            ) : (
                <ListContainer>
                    <EmptyListMessage />
                </ListContainer>
            )
        )}
    </>;
};